import React from 'react';

import * as S from './styles';

export const ModalHeader: React.FC = ({ children }) => {
  return <S.Container>{children}</S.Container>;
};
